module.exports = __webpack_public_path__ + "static/media/dev2.b00b2557.svg";